const NAMESPACE = "editRecipientContactInfo";

const KEYS = {
    emailInputLabel: "emailInputLabel",
    firstNameInputLabel: "firstNameInputLabel",
    lastNameInputLabel: "lastNameInputLabel"
};

const MESSAGES = {
    [KEYS.emailInputLabel]: {
        value: "Email",
        comment: "Input to edit the recipient's email"
    },
    [KEYS.firstNameInputLabel]: {
        value: "First Name",
        comment: "Input to edit the recipient's first name"
    },
    [KEYS.lastNameInputLabel]: {
        value: "Last Name",
        comment: "Input to edit the recipient's last name"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
